// src/App.js
import React from "react";
import UploadSection from "./components/UploadSection";

function App() {
  return (
    <div>
      <UploadSection />
    </div>
  );
}

export default App;
